document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tabList");
  const tabSets = document.querySelectorAll(".tabSet");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const currentActive = document.querySelector(".tabSet.active");
      const targetTab = tab.getAttribute("data-prd_tab");
      const targetSet = document.querySelector(`.tabSet[data-prd_tab="${targetTab}"]`);

      tabs.forEach((t) => t.classList.remove("on"));
      tab.classList.add("on");

      if (currentActive && currentActive !== targetSet) {
        currentActive.classList.add("fade-out");
        setTimeout(() => {
          currentActive.classList.remove("active", "fade-out");
          currentActive.style.display = "none";
          targetSet.style.display = "block";
          setTimeout(() => targetSet.classList.add("active"), 10);
        }, 300);
      } else {
        targetSet.style.display = "block";
        setTimeout(() => targetSet.classList.add("active"), 10);
      }
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const restoreBtn = document.querySelector(".restoreBtn");
  const xpurchase = document.getElementById("xpurchase");

  if (restoreBtn && xpurchase) {
    xpurchase.appendChild(restoreBtn);
  }
});

// [hash]
// -1474687572
//
// [config]
// elementType: button
// elementTypePartially: button
// anchor: .product-form.unavailable
// anchorPosition: beforeend
// anchorSame: true
// anchorPositionPartially: beforebegin
// detectionName: current
// classes: product-submit action-button submit
// style: margin-top: -10px
// styleSame: true
// spacers: false
// syncWidth: false
// keepAbove: false
// selectable: true
// refreshOnChange: true
// refreshOnClick: false
// refreshOnSoldoutChange: false
//
if (typeof BIS !== 'undefined') {
if (BIS.urlIsProductPage() === true) {
  BIS.popup.ready.then(function() {

    // Exit script if product has no sold out variants.
    if (BIS.popup.variants.length < 1) {
      return;
    }


    // Build button that will be inserted in the product page.
    var button = document.createElement('button');
    button.setAttribute('id', 'BIS_trigger');
    button.setAttribute('type', 'button');
    button.setAttribute('class', 'product-submit action-button submit');
    button.style.cssText = 'margin-top: -10px';
    button.textContent = BIS.currentButtonCaption();

        // Insert the button into the product page.
    BIS.inlineButtonAnchor = '.product-form.unavailable';
    var anchor = document.querySelector(BIS.inlineButtonAnchor);
    if (!anchor) return;
    anchor.insertAdjacentElement('beforeend', button);



    // Control button visibility
    var variantId;
    var originalDisplay = button.style.display;
    BIS.refreshInlineButton = function() {
      try {
        var variant = BIS.detectVariant(BIS.popup);

        if (variant && BIS.popup.variantIsUnavailable(variant)) {
          variantId = variant.id;
          button.style.display = originalDisplay;
        } else {
          button.style.display = 'none';
        }
      } catch (e) {
        console.log(e);
      }
    };
    
    BIS.refreshInlineButton()
    
    BIS.delayedRefreshInlineButton = function() {
      setTimeout(function() { BIS.refreshInlineButton() }, 15)
    };

    // Refresh button visibility on document change.
    document.addEventListener('change', BIS.delayedRefreshInlineButton);



    // Select the variant in popup form.
    button.addEventListener('click', function() {
      BIS.popup.form.selectVariant(variantId);
    });


  });
}

document.addEventListener('DOMContentLoaded', function () {
  // 初期表示時の処理
  updateRestockButtonVisibility();

  // バリエーションが変更されたときの処理
  document.querySelector('form').addEventListener('change', function () {
    updateRestockButtonVisibility();
  });

  function updateRestockButtonVisibility() {
    // 現在選択されているバリエーション
    var selectedVariant = window.Shopify?.Analytics?.product?.selected_or_first_available_variant;

    if (!selectedVariant) return;

    var button = document.getElementById('BIS_trigger');
    if (!button) return;

    // 在庫がない場合にボタンを表示
    if (selectedVariant.available === false) {
      button.style.display = 'inline-block';
    } else {
      button.style.display = 'none';
    }
  }
});
}
